import React from 'react';
import PropTypes from 'prop-types';
import AlertMessage from '../AlertMessage/AlertMessage';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import styles from './AlertMessageWithButton.css';

const AlertMessageWithButton = ({
  error = '',
  btnStyle = '',
  btnText = '',
  onClick = () => {}
}) => {
  return (
    <>
      {error !== '' && (
        <>
          <AlertMessage message={error} />
          <div className="button-container">
            <MFBeaconButton
              id="alertMsgButton"
              variant="primary"
              className={btnStyle}
              onClick={onClick}
              label={btnText}
            />
          </div>
          <style jsx>{styles}</style>
        </>
      )}
    </>
  );
};

AlertMessageWithButton.propTypes = {
  error: PropTypes.string,
  btnStyle: PropTypes.string,
  btnText: PropTypes.string,
  onClick: PropTypes.func
};

export default AlertMessageWithButton;
